import React from 'react';

import Box from '@mui/material/Box';

import { StyledSidebar } from './Sidebar.styles';
import { NavGroup } from './Sidebar.types';
import SidebarFooter from './SidebarFooter';
import SidebarHeader from './SidebarHeader';
import SidebarNavList from './SidebarNavList';
import SidebarProjectSwitcher from './SidebarProjectSwitcher';

interface SidebarContentProps {
  groups: NavGroup[];
  isCollapsed: boolean;
  variant: 'temporary' | 'permanent';
  currentPath: string;
  currentSearch: string;
  onToggleCollapsed: () => void;
  onClose?: () => void;
  onSignOut: () => void;
}

const SidebarContent: React.FC<SidebarContentProps> = ({
  groups,
  isCollapsed,
  variant,
  currentPath,
  currentSearch,
  onToggleCollapsed,
  onClose,
  onSignOut,
}) => (
  <StyledSidebar className={isCollapsed ? 'collapsed' : ''}>
    <SidebarHeader
      isCollapsed={isCollapsed}
      variant={variant}
      onToggleCollapsed={onToggleCollapsed}
      onClose={onClose}
    />
    <Box
      sx={{
        flex: 1,
        overflow: 'auto',
        px: 1.5,
        '&::-webkit-scrollbar': { width: '4px' },
        '&::-webkit-scrollbar-track': { background: 'transparent' },
        '&::-webkit-scrollbar-thumb': { backgroundColor: 'divider', borderRadius: '4px' },
      }}
    >
      <SidebarProjectSwitcher isCollapsed={isCollapsed} />
      <SidebarNavList
        groups={groups}
        isCollapsed={isCollapsed}
        currentPath={currentPath}
        currentSearch={currentSearch}
        onNavigate={onClose}
      />
    </Box>
    <SidebarFooter isCollapsed={isCollapsed} onSignOut={onSignOut} />
  </StyledSidebar>
);

export default SidebarContent;
